import * as Sentry from '@sentry/react';
import { Component, ErrorInfo, ReactNode } from 'react';
import './ErrorBoundary.sass';

interface Props {
  fallback?: ReactNode;
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    // Caught here, so it never reaches window.onerror — Sentry's own
    // instrumentation never sees it unless we report it ourselves.
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
  }

  public render() {
    if (this.state.hasError) {
      return this.props.fallback ? (
        this.props.fallback
      ) : (
        <span className="error-boundary-fallback">
          Something went wrong displaying this component
        </span>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
